var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2315_187138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6374 34.4434C21.604 35.1334 23.1899 35.1658 28.3952 34.603C33.9048 34.0037 35.0984 33.6711 34.8537 32.8792C34.5039 31.7944 21.72 33.3289 21.6374 34.4434Z",
    fill: "#BCDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.037 10.405C14.9705 10.4525 14.713 10.8129 13.4691 15.3803C12.1795 20.0965 12.1118 21.0039 12.9756 21.3188C14.5442 21.8833 15.286 20.7439 17.172 14.99C18.5611 10.7441 18.5623 10.3699 17.037 10.405Z",
    fill: "#BCDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.626 17.2517C27.1396 17.2662 26.6052 17.5739 24.894 19.3756C19.8386 24.7396 15.8019 28.1701 18.6946 28.0839C19.8754 28.0567 20.9181 27.1565 27.0402 21.0788C30.4086 17.703 30.6146 17.2454 28.626 17.2517Z",
    fill: "#BCDD33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2315_187138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.0145,
    height: 33.0145,
    fill: "white",
    transform: "translate(0.902344 16.168) rotate(-27.8824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.5fba156cafebaf07f665ef6b50ccb0b1.svg";
export { ForwardRef as ReactComponent };